import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/components/EventsAwardsAccordionHeader";
import { BUSINESS_URL } from "@util/constant";

/**
 * Component to render business times section on Partners page
 */
const BusinessTimesSection = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150 leading-[1.4]"
      data-testid="business-times-section-component"
    >
      <AccordionV2
        testId="business-times-section-component"
        className="rounded-tl-lg rounded-tr-lg border border-gray-175 bg-gray-150 py-4"
        headerChildren={
          <EventsAwardsAccordionHeader title="The Business Times" />
        }
        arrowClassName="border-none h-auto w-auto -rotate-90 mr-6"
        isArrowRight
      >
        <div className="mt-4 border-t border-gray-175 px-6 pt-4">
          <p>
            The Business Times, published by SPH Media Trust, is South-east
            Asia&apos;s leading financial daily. BT brings to its readers daily
            corporate, financial, economic and political news, analysis and
            commentary on print and digital platforms. It provides readers with
            in-depth coverage of Singapore and Asian business and economic
            developments, as well as global trends that impact Singapore
            business. BT&apos;s lifestyle journalists bring busy executives the
            latest in recreation, entertainment, the arts, design, food and
            shopping. For more information, please visit&nbsp;
            <a
              href={BUSINESS_URL}
              className="font-bold text-blue-175 hover:text-gray-850 hover:underline"
            >
              businesstimes.com.sg
            </a>
            .
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default BusinessTimesSection;
